import { ActiveCartItem } from 'types/cart';

export const getAppOnlyDateTimes = (cartItem: ActiveCartItem) => {
  if (cartItem.__typename === 'ProductCartItem') {
    return {
      from: cartItem.product.appOnlyDateTimeFrom,
      to: cartItem.product.appOnlyDateTimeTo,
    };
  }
  return { from: null, to: null };
};
